import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setCondition, setConditionFailure, setConditionIdle, setConditionSuccess } from '../actions';

const status_set_condition = handleActions(
  {
    [setCondition.toString()]: (state, action) => 'LOADING',
    [setConditionSuccess.toString()]: (state, action) => 'SUCCESS',
    [setConditionFailure.toString()]: (state, action) => 'FAILURE',
    [setConditionIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_set_condition = handleActions(
  {
    [setCondition.toString()]: () => null,
    [setConditionSuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { status_set_condition, data_set_condition };
